import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import {
  client_list_action,
  client_delete_action,
} from "../../../actions/master_actions/client_action";
import { fill_action } from "../../../actions/fillList_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { countryActionId, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import Header from "../../../common_components/Header";
import Pagination from "../../../utils/pagination";
class Client extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userId: "",
      ClientID: "",
      CompanyName: "",
      ContactPerson: "",
      Designation: "",
      Designation: "",
      PrimaryEmailID: "",
      CountryID: "",
      clientData: [],
      countryList: [],
      isAccordionExpanded: false,
      currentPage: 1,
    };
    this.getClientList = this.getClientList.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.clientRecord = this.clientRecord.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
          sessionStorage.getItem("roleId") == 4 ?
              this.props.navigate('/checkList') :
              <></>
      }
     }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.getClientList();
    this.getFillList(countryActionId, userId, "", "");
  }
  navigateClientUpdate(ClientID,StatusID) {
    console.log(ClientID);
    this.props.navigate("/client_add", {
      state: { ClientID: ClientID,StatusID:StatusID },
    });
  }
  updateItem(item) {
    this.setState({ currentPage: item });
  }
  clientRecord(clientData) {
    // const { userList } =this.state
    return (
      <table class="table table-bordered table-striped" id="dashboard-table">
        <thead>
          <tr>
            <th>ClientID</th>
            <th>Company Name</th>
            <th>Country</th>
            <th>Contact Person</th>
            <th>Designation</th>
            <th>Primary Email</th>
            <th>Password</th>
            <th>Status</th>
            <th className="text-right" style={{ width: "5%" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
        {clientData != "" && clientData != null ? (
          clientData.map((data, i) => (
              <tr>
                <td>{data.ClientID}</td>
                <td>{data.CompanyName}</td>
                <td>{data.CountryName}</td>
                <td>{data.ContactPerson}</td>
                <td>{data.Designation}</td>
                <td>{data.PrimaryEmailID}</td>
                <td>{data.Password}</td>
                <td>{data.StatusID==1?"Active":"Inactive"}</td>
                <td className="text-right">
                  <a
                    href="javascript:void(0);"
                    onClick={() => {
                      console.log("data.ClientID:", data.ClientID);
                      this.navigateClientUpdate(data.ClientID,data.StatusID);
                    }}
                    title="Edit"
                    className="btn btn-sm"
                  >
                    <i className="fa fa-edit action_btn_table" />
                  </a>
                  {data.StatusID==1?(

                    <a
                    onClick={() => this.handleDelete(data.ClientID)}
                    title="Delete"
                    className="btn btn-sm delete_record"
                    >
                    <i className="fa fa-trash action_btn_table" />
                  </a>
                  ):<></>}
                </td>
              </tr>
          ))
          ) : (
            <tr>
              <td colSpan="8">No data available</td>
            </tr>
            )}
            </tbody>
      </table>
    );
  }
  navigateClientAdd() {
    this.props.navigate("/client_add");
  }
  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        console.log(data, "CountryFillList");
        if (data.error != 1) {
          if (value == countryActionId) {
            this.setState({ countryList: data.data, isLoading: false });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getClientList = async () => {
    const { userId, CompanyName,ContactPerson, Designation, PrimaryEmailID, CountryID,StatusID } =
      this.state;
    this.setState({ isLoading: true });
    this.props
      .client_list_action(
        CompanyName,
        ContactPerson,
        Designation,
        PrimaryEmailID,
        CountryID,StatusID
      )
      .then((data) => {
        console.log(data, "from UI Client");
        if (data.error !== 1) {
          this.setState({
            clientData: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          toast.error(data.msg, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      console.log(this.state.clientData);
    }, 500);
  };
  handleDelete(ClientID) {
    const userId = 0;

    const confirmed = window.confirm(
      "Are you sure you want to delete this Client?"
    );

    if (confirmed) {
      this.props
        .client_delete_action(userId, ClientID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getClientList(); // Refresh the holiday list after deletion
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  render() {
    const {
      isLoading,
      clientData,
      countryList,
      CompanyName,
      Designation,
      PrimaryEmailID,
      ContactPerson,
      CountryID,
      isAccordionExpanded,
      currentPage,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = clientData.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(clientData.length / recordsPerPage);

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[11]} />

            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">Client List</h4>
                  <div>
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.navigateClientAdd()}
                      className="btn btn-primary btn-sm create_btn"
                    >
                      <span className="hidden-xs">Add</span>
                    </a>
                  </div>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search</h4>
                        <div className="searched_items">
                          <h5>
                            Company Name : <span>{CompanyName}</span>
                          </h5>
                          <h5>
                            Country : <span>{CountryID}</span>
                          </h5>
                          <h5>
                            Contract Person : <span>{ContactPerson}</span>
                          </h5>
                          <h5>
                            Designation : <span>{Designation}</span>
                          </h5>
                          <h5>
                            PrimaryEmailID : <span>{PrimaryEmailID}</span>
                          </h5>
                          {/* <div class="chip">
              John Doe <span class="closebtn" onclick="this.parentElement.style.display='none'">&times;</span>
            </div> */}
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${
                          isAccordionExpanded ? "show" : ""
                        }`}
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Company Name</label>
                                <input
                                  type="text"
                                  value={CompanyName}
                                  onChange={(e) =>
                                    this.setState({
                                      CompanyName: e.target.value,
                                    })
                                  }
                                  className="form-control search_form_control"
                                  placeholder="Enter Company Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Country</label>
                                <select
                                  className="form-control"
                                  value={CountryID}
                                  onChange={(e) =>
                                    this.setState({
                                      CountryID: e.target.value,
                                    })
                                  }
                                >
                                  <option>Select</option>
                                  {countryList.length > 0
                                    ? countryList.map((data) => (
                                        <option
                                          key={data.CountryID}
                                          value={data.CountryID}
                                        >
                                          {data.CountryName}
                                        </option>
                                      ))
                                    : null}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Contract Person</label>
                                <input
                                  type="text"
                                  value={ContactPerson}
                                  onChange={(e) =>
                                    this.setState({
                                      ContactPerson: e.target.value,
                                    })
                                  }
                                  className="form-control search_form_control"
                                  placeholder="Enter Contract Person"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Designation</label>
                                <input
                                  value={Designation}
                                  onChange={(e) =>
                                    this.setState({
                                      Designation: e.target.value,
                                    })
                                  }
                                  type="text"
                                  className="form-control search_form_control"
                                  placeholder="Enter Designation"
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Primary Email</label>
                                <input
                                  value={PrimaryEmailID}
                                  onChange={(e) =>
                                    this.setState({
                                      PrimaryEmailID: e.target.value,
                                    })
                                  }
                                  type="email"
                                  className="form-control search_form_control"
                                  placeholder="Enter Primary Email"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button
                                onClick={()=>this.getClientList()}
                                className="btn btn-primary search_btn"
                              >
                                Search
                              </button>
                              &nbsp;&nbsp;
                              <button
                               onClick={()=>{
                                this.setState({
                                  CompanyName:"",
                                  CountryID:"",
                                  ContactPerson:"",
                                  Designation:"",
                                  PrimaryEmailID:""
                                },()=>this.getClientList())
                              }}
                                className="btn btn-primary search_btn"
                              >
                                Clear Filters
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="custom_table d-flex">
                  <div class="hack1">
                    <div class="hack2">
                      {this.clientRecord(currentRecords)}
                      {clientData.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div class="page-header">
    <h4 class="page-title">Client List</h4>
    <div>
      <a href="javascript:void(0);" data-toggle="modal" data-target="#createClient"><span class="material-symbols-outlined add_circle_icon">add</span></a>
      <a href="javascript:void(0);" data-toggle="modal" data-target="#Filter_modal"><span class="material-symbols-outlined filter_circle_icon">filter_alt</span></a>
    </div>
  </div> */}
              </div>
            </section>
          </main>
         
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { client_list_action, client_delete_action, fill_action })(
    Client
  )
);
